<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="title font-weight-light mb-2 black--text">
          <v-icon left color="black">mdi-plus</v-icon>
          <span>Yeni Ürün Oluştur</span>
          <v-divider class="mt-2"></v-divider>
        </h1>
        <p
          class="text-caption grey--text text--darken-2 mb-2"
        >Ürün oluşturmak için ürün bilgilerini girin</p>
      </v-col>
    </v-row>
    <v-stepper v-model="urunStepper">
      <v-stepper-header>
        <v-stepper-step :complete="urunStepper > 1" step="1" editable>Ürün Bilgileri</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="urunStepper > 2" step="2" editable>Ürün Varyasyonları</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="urunStepper > 3" step="3" editable>Ürün Seçenekleri</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="urunStepper > 4" step="4" editable>Ürün Özellikleri</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="5" editable>Ürün Açıklaması</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <div class="py-2">
            <div class="mb-2">
              <p class="font-body-2 my-0">
                <v-icon color="black" class="mb-1">mdi-chevron-right</v-icon>Ürün Bilgileri
                <v-divider></v-divider>
              </p>
              <v-text-field
                v-model="urunData.urunAdi"
                prepend-icon="mdi-shoe-cleat"
                label="Ürün adını girin"
                hint="Örn: Nike Air Max Premium"
                class="font-weight-light"
                persistent-hint
              ></v-text-field>
              <v-text-field
                v-model="urunData.urunKodu"
                prepend-icon="mdi-qrcode"
                label="Ürün Kodu"
                hint="Ürün için bir kod belirleyin (Örn: AX-854512-1)"
                class="font-weight-light"
              ></v-text-field>
              <v-select
                prepend-icon="mdi-selection-ellipse-arrow-inside"
                v-model="urunData.urunKategorisi"
                hint
                :items="kategoriListesi"
                item-text="name"
                item-value="code"
                label="Ürün kategorisi"
                persistent-hint
              ></v-select>
            </div>
          </div>
          <div class="d-flex justify-end">
            <v-btn color="success" @click="urunStepper = 2">
              İlerle
              <v-icon size="22" right>mdi-chevron-right</v-icon>
              </v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-row>
            <v-col cols="12">
              <v-alert type="info" color="blue">
                <h2>Varyasyonlar</h2>
                <div
                  class="mb-3"
                >Ürüne varyasyon eklemesi yapmak istiyor musunuz ? Varyasyon eklemek için aşağıdan aktif edebilirsiniz:</div>
                <v-btn
                  color="white"
                  class="mr-2"
                  :light="!urunVaryasyonDurum"
                  :depressed="urunVaryasyonDurum"
                  small
                  :class="urunVaryasyonDurum ? 'blue lighten-1' : ''"
                  @click="urunVaryasyonDurum = !urunVaryasyonDurum"
                >
                  <v-icon class="mr-1">mdi-{{urunVaryasyonDurum ? 'not-equal-variant' : 'equal'}}</v-icon>
                  {{urunVaryasyonDurum ? 'Varyasyonları İptal Et' : 'Varyasyonları Aktif Et'}}
                </v-btn>
              </v-alert>
            </v-col>
            <v-col v-show="urunVaryasyonDurum">
              <p class="font-body-2">
                <v-icon color="black" class="mb-1">mdi-chevron-right</v-icon>Ana Varyasyon Seçimi
                <v-divider></v-divider>
              </p>
              <v-btn-toggle v-model="urunNiteligi" mandatory>
                <v-btn
                  :value="item.name"
                  :key="key"
                  v-for="(item, key) in urunNitelikleri"
                  class="text-capitalize font-weight-regular"
                  :color="urunNiteligi == item.name ? 'grey darken-4 white--text' : 'grey lighten-3'"
                >
                  <v-icon
                    :color="urunNiteligi == item.name ? 'white' : ''"
                    size="18"
                    class="mr-2"
                  >mdi-label</v-icon>
                  {{item.name}}
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
          <transition-group name="fade" tag="div" v-show="urunVaryasyonDurum">
            <v-row v-if="urunNiteligi === 'Tek Ürün'" :key="1">
              <v-col cols="12" class="py-0">
                <v-alert
                  class="grey lighten-3 font-weight-light text-body-2 mb-0"
                  border="bottom"
                  colored-border
                  color="grey darken-3"
                  type="info"
                  elevation="2"
                >Tek tip bir ürünün niteliği bulunmaz</v-alert>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  :label="urunNitelikleri.find(o => o.name === urunNiteligi).name"
                  prepend-inner-icon="mdi-label"
                  outlined
                  persistent-hint
                  hint="Listeden ürün niteliklerinin seçimini yapınız"
                  :items="urunNitelikleri.find(o => o.name === urunNiteligi).value"
                  @change="nitelikSecimi"
                  disabled
                  v-show="false"
                >
                  <template>Tek Ürün Ürün</template>
                </v-combobox>
              </v-col>
            </v-row>
            <v-row v-else-if="urunNiteligi === 'Renk Seçici'" :key="2">
              <v-col cols="12" class="py-0">
                <v-alert
                  class="grey lighten-3 font-weight-light text-body-2 mb-0"
                  border="bottom"
                  colored-border
                  color="purple"
                  type="info"
                  elevation="2"
                >
                  Ürün renklerini tanımlayın ve renklere göre kategorilendirerek
                  her birisi için
                  <b>fiyat</b>,
                  <b>stok</b>,
                  <b>boyut</b> ve
                  <b>görsel</b> tanımlayın.
                </v-alert>
              </v-col>
              <v-col cols="12">
                <ColorBox
                  v-model="urunData.urunNitelikleri"
                  @change="nitelikSecimi"
                  :hide-mode-switch="true"
                />
              </v-col>
            </v-row>
            <v-row v-else-if="urunNitelikleri.map(o => o.name).includes(urunNiteligi)" :key="3">
              <v-col>
                <v-combobox
                  v-model="urunData.urunNitelikleri"
                  :label="urunNitelikleri.find(o => o.name === urunNiteligi).name"
                  prepend-inner-icon="mdi-label"
                  outlined
                  :multiple="urunNiteligi != 'Tek Ürün' ? true : false"
                  persistent-hint
                  hint="Listeden ürün niteliklerinin seçimini yapınız"
                  :items="urunNitelikleri.find(o => o.name === urunNiteligi).value"
                  @change="nitelikSecimi"
                >
                  <template v-slot:selection="{item}">
                    <v-chip color="grey darken-3" dark label>{{item}}</v-chip>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
          </transition-group>
          <v-row>
            <v-col cols="12" class="pb-0">
              <p class="font-body-2 mb-0">
                <v-icon color="black" class="mb-1">mdi-chevron-right</v-icon>Renk Özellikleri
                <v-divider></v-divider>
              </p>
              <p class="text-caption grey--text text--darken-1">
                Her renk için seçim yaparak, her birisi için ayrı ayrı ürün
                bilgilerini ve görsellerini girin
              </p>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
              <v-col
                class="d-inline-flex"
                :key="key"
                v-for="(nitelik, key) in urunData.urunNitelikleri"
              >
                <v-card
                  width="100%"
                  @click="aktifNitelik = nitelik"
                  elevation="3"
                  :style="{
                border: '1px solid' + (nitelik.match(/^#/) ? nitelik : defaultColor),
                'background-color': '#f5f5f5',
              }"
                >
                  <v-row class="mx-0">
                    <v-col cols="3" class="d-flex justify-start align-center">
                      <v-btn
                        v-if="nitelikTuru == 1"
                        small
                        class="text-capitalize"
                        rounded
                        color="grey darken-4"
                        depressed
                        outlined
                      >Tek Ürün</v-btn>
                      <v-btn
                        v-else-if="nitelikTuru == 2"
                        fab
                        class="card-renk-button elevation-2"
                        :style="aktifNitelikButon(nitelik)"
                      >
                        <v-icon size="30">mdi-shoe-cleat</v-icon>
                      </v-btn>
                      <v-btn
                        v-else-if="nitelikTuru == 3"
                        small
                        class="card-renk-button elevation-2 text-capitalize"
                        rounded
                        :style="aktifNitelikButon(nitelik)"
                      >
                        <v-icon size="20" class="mr-1">mdi-label</v-icon>
                        {{nitelik}}
                      </v-btn>
                    </v-col>
                    <v-col class="d-flex align-center pl-0">
                      <div id="cardFiyatStok" class="text-body-1 font-weight-light d-flex mr-2">
                        <span>
                          <b>Fiyat:</b>
                          <span class="d-inline-block">{{urunFiyati[nitelik]}}</span>
                        </span>
                        <span>
                          <v-icon>mdi-power-on</v-icon>
                        </span>
                        <span>
                          <b>Stok:</b>
                          {{ getStok(nitelik) ? getStok(nitelik) : "0" }}
                        </span>
                      </div>
                      <span v-if="nitelik !== aktifNitelik">
                        <v-btn fab small color="grey lighten-3" class="elevation-0">
                          <v-icon color="grey">mdi-pencil</v-icon>
                        </v-btn>
                      </span>
                      <span v-else>
                        <v-sheet color="transparent" width="40px" height="40px">
                          <!-- <v-icon class="px-2 py-2" color="grey lighten-1">mdi-chevron-double-right</v-icon> -->
                        </v-sheet>
                      </span>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-col>
            <v-col cols="8" class="px-0 py-0">
              <v-col cols="12" class="py-0">
                <v-row>
                  <v-col xl="7" lg="9" class="urun-fiyatlandirma-wrapper">
                    <div>
                      <currency-input
                        v-for="nitelik in urunData.urunNitelikleri"
                        v-show="nitelik === aktifNitelik"
                        :key="nitelik"
                        v-model="urunData.urunFiyati[nitelik]"
                        :options="{ currency: 'TRY', currencyDisplay: 'hidden' }"
                        :attrs="{
                      'prepend-inner-icon': 'mdi-currency-try',
                      'label': !urunFiyatiIndirimStatus[nitelik] ? 'Ürün Fiyatı' : 'İndirimli Fiyat',
                      'hint': 'Ürün fiyatını belirleyin',
                      'persistent-hint': true,
                      'class': 'font-weight-light',
                      'outlined': true,
                    }"
                        :class="urunFiyatiIndirimStatus[nitelik] ? 'mr-2' : null"
                      >
                        <template v-slot:append>
                          <v-btn
                            class="indirim-btn"
                            color="red"
                            dark
                            small
                            @click="indirimBelirleKaldir"
                          >
                            <v-icon size="18">mdi-flash</v-icon>
                            {{!urunFiyatiIndirimStatus[aktifNitelik] ? 'İndirimde Belirle' : 'İptal'}}
                          </v-btn>
                        </template>
                      </currency-input>
                    </div>
                    <div v-show="urunFiyatiIndirimStatus[aktifNitelik]">
                      <currency-input
                        v-for="nitelik in urunData.urunNitelikleri"
                        v-show="nitelik === aktifNitelik && urunFiyatiIndirimStatus[nitelik]"
                        :key="nitelik"
                        ref="urunEskiFiyati"
                        v-model="urunData.urunEskiFiyati[nitelik]"
                        :options="{ currency: 'TRY', currencyDisplay: 'hidden' }"
                        :attrs="{
                            'prepend-inner-icon': 'mdi-currency-try',
                            'label': 'Eski Fiyat',
                            'hint': 'Ürünün eski fiyatını girin',
                            'persistent-hint': true,
                            'class': 'font-weight-light',
                            'outlined': true,
                          }"
                      >
                        <template v-slot:append>
                          <v-chip
                            v-show="urunEskiFiyati[nitelik]"
                            label
                            dark
                            small
                            :color="defaultColor"
                            class="font-weight-medium"
                          >{{urunEskiFiyati[aktifNitelik]}}</v-chip>
                        </template>
                      </currency-input>
                    </div>
                  </v-col>
                  <v-col>
                    <v-text-field
                      :value="urunData.urunStok[aktifNitelik]"
                      prepend-inner-icon="mdi-stocking"
                      label="Stok"
                      hint="Ürün stok durumu"
                      persistent-hint
                      class="font-weight-light"
                      :rules="[rules.number]"
                      @keyup="filterStok($event)"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="mb-8">
                <p class="font-body-2 my-0">
                  <v-icon color="black" class="mb-1">mdi-chevron-right</v-icon>Ürün Resimleri
                  <v-divider></v-divider>
                </p>
                <p class="my-2 text-caption grey--text text--darken-2">
                  Ürün resimlerini sürükle bırak yöntemi ile yeniden
                  sıralayabilirsiniz
                </p>
                <ResimEkle
                  :buttonstyle="aktifNitelikButon()"
                  v-model="urunData.urunResimleri[aktifNitelik]"
                />
              </v-col>
              <v-col cols="12" class="py-3 rounded-lg mb-5 grey lighten-3">
                <p class="font-body-2 mb-0 d-flex align-center">
                  <v-icon left size="20">mdi-apps</v-icon>
                  <span class="mr-3">Varyasyon Grupları</span>
                  <span>
                    <v-btn
                      :style="aktifNitelikButon()"
                      class="elevation-0"
                      dark
                      x-small
                      @click="urunSecenekleriDialog"
                    >
                      <v-icon left>mdi-format-list-checks</v-icon>Varyasyon Listesi
                    </v-btn>
                  </span>
                </p>
                <span
                  class="text-caption"
                >Listeden ürün için varyasyonları gruplayarak gruplar içerisinde seçim yapabilirsiniz</span>
              </v-col>
              <v-col
                cols="12"
                class="py-0 mb-5"
                :key="nitelikAdi"
                v-for="(nitelik, nitelikAdi) in urunData.urunSecenekleri[aktifNitelik]"
              >
                <p class="font-body-2 mb-2">
                  <v-icon color="black" class="mb-1">mdi-chevron-right</v-icon>
                  <span class="mr-3">{{nitelikAdi}}</span>
                  <span>
                    <v-btn
                      :style="!tumSeceneklerAktif(nitelikAdi) ? {'background-color': '#ddd', 'color': '#252525'} : aktifNitelikButon()"
                      class="elevation-0"
                      dark
                      x-small
                      @click="tumSecenekleriSecKaldir(nitelikAdi)"
                    >{{ !tumSeceneklerAktif(nitelikAdi) ? "Tümünü Seç" : "Tümünü Kaldır" }}</v-btn>
                  </span>
                  <v-divider></v-divider>
                </p>
                <v-chip-group multiple v-model="urunData.urunSecenekleri[aktifNitelik][nitelikAdi]">
                  <v-chip
                    v-for="(name, key) in urunNitelikleri.find(o => o.name === nitelikAdi).value"
                    :key="key"
                    :value="name"
                    label
                    :style="urunData.urunSecenekleri[aktifNitelik][nitelikAdi].includes(name) ? aktifNitelikButon(): {}"
                  >{{ name }}</v-chip>
                </v-chip-group>
              </v-col>
            </v-col>
          </v-row>

          <v-row>
            
          </v-row>

          <v-btn color="primary" @click="urunStepper = 3">Continue</v-btn>

          <v-btn text>Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-row>
            <v-col v-if="urunData.urunOzellikleri" cols="12" class="py-0 mb-2">
              <p class="font-body-2 my-0">
                <v-icon color="black" class="mb-1">mdi-chevron-right</v-icon>Ürün Özellikleri
                <v-divider></v-divider>
              </p>
            </v-col>
            <v-col
              cols="4"
              class="d-flex align-center py-2"
              :key="key"
              v-for="(alan, key) in urunAlanlari"
            >
              <div class="urun-alan font-weight-regular">
                <v-icon size="5" class="mb-1">mdi-checkbox-blank-circle</v-icon>
                {{ alan }}:
              </div>
              <v-text-field
                label="Giriniz"
                hide-details
                class="font-weight-light pt-0"
                outlined
                dense
                filled
                v-model="urunData.urunOzellikleri[alan]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-btn color="primary" @click="urunStepper = 4">Continue</v-btn>
          <v-btn text>Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-row>
            <v-col cols="12" class="mt-3">
              <p class="font-body-2 mb-3">
                <v-icon color="black" class="mb-1">mdi-chevron-right</v-icon>Ürün Açıklaması
                <v-divider></v-divider>
              </p>
              <div>
                <cheetah-editor
                  v-model="urunData.urunAciklamasi"
                  :set-content="urunSetEditorContent"
                  editor-base-color="grey darken-3"
                  editor-selecting-color="grey darken-4"
                  editor-passive-color="grey lighten-3"
                  editor-border-color="#aaaaaa"
                />
              </div>
            </v-col>

            <v-col cols="12" class="mb-2">
              <div class="d-flex justify-end grey lighten-3">
                <v-btn
                  color="red darken-2"
                  class="mr-3"
                  dark
                  @click="router.push('/panel/urunler/urun-listesi')"
                >
                  <v-icon left>mdi-cancel</v-icon>İptal
                </v-btn>
                <v-btn color="green darken-1" dark @click="urunEkle" :loading="urunEkleBtnStatus">
                  <v-icon left>mdi-plus-circle</v-icon>Ürünü Ekle
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-card>
      <v-row class="mx-0">
        <!-- <v-col cols="12" lg="4">
          <h1 class="title font-weight-light mb-2 black--text">
            <v-icon left color="black">mdi-magnify</v-icon>
            <span>Önizleme</span>
            <v-divider class="mt-2"></v-divider>
          </h1>
          <p
            class="text-caption grey--text text--darken-2 mb-2"
          >Ürün önizlemesini görüntüleyebilirsiniz</p>
          <transition name="fade">
            <div id="onizleme" v-show="urunData.urunAdi">
              <div class="card--style2 card--one mx-auto" data-aos="fade-up">
                <div class="shoe--info">
                  <span class="shoe--name">{{ urunData.urunAdi }}</span>
                  <span class="shoe--price">{{ urunFiyati[aktifNitelik] }} ₺</span>
                  <span class="shoe--code">{{ urunData.urunKodu }}</span>
                </div>

                <div class="shoe">
                  <div class="onizleme-yok">
                    <div>Ürün için görsel eklenmedi</div>
                  </div>
                  <img src="@/assets/shoe-2.png" />
                </div>

                <div class="shoe--colors">
                  <ul class="colors">
                    <li
                      :key="renk"
                      v-for="renk in urunData.urunNitelikleri"
                      :style="{ background: renk }"
                    ></li>
                  </ul>
                </div>
              </div>
            </div>
          </transition>
          <div id="onizlemeBilgiGir" v-show="!urunData.urunAdi">
            <div>Önizlemek için ürün bilgilerini giriniz</div>
          </div>
        </v-col>-->
      </v-row>
    </v-card>
    <v-dialog v-model="urunSecenekleriData.dialog" max-width="500">
      <v-card>
        <v-card-title>
          Ürün Seçenekleri Listesi
          <v-spacer></v-spacer>
          <v-btn icon @click="urunSecenekleriData.dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-2">
          <v-list>
            <v-list-item :key="key" v-for="(item, key) in urunNitelikleri.filter((o,i) => i > 1)">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon color="grey darken-4" class="mr-1">mdi-label</v-icon>
                  {{item.name}}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  small
                  color="blue"
                  dark
                  v-if="!secenekKontrol(item.name)"
                  @click="secenekEkle(item.name)"
                >Ekle</v-btn>
                <v-btn small color="red" dark v-else @click="secenekEkle(item.name)">Kaldır</v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="nitelikDegisDialog">
      <v-card></v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import ResimEkle from "@/components/Modules/Urunler/ResimEkle.vue";
import ColorBox from "@/components/Settings/SystemSettings/Inputs/ColorBox.vue";
import TinyColor from "tinycolor2";
import AciklamaEditor from "@/components/Modules/Urunler/AciklamaEditor.vue";
import axios from "axios";
import UrunlerService from "@/services/UrunlerService";
import CheetahEditor from "../../../components/CheetahEditor.vue";
import CurrencyInput from "../../../components/Modules/Urunler/CurrencyInput.vue";

export default {
  name: "UrunEkle",
  components: {
    ResimEkle,
    ColorBox,
    AciklamaEditor,
    CheetahEditor,
    CurrencyInput
  },
  data() {
    return {
      urunStepper: 2,
      urunVaryasyonDurum: false,
      urunData: {
        urunAdi: "",
        urunKodu: "",
        urunKategorisi: "",
        urunFiyati: [],
        urunEskiFiyati: [],
        urunStok: {},
        urunNitelikleri: [],
        urunResimleri: {},
        urunOzellikleri: {},
        urunSecenekleri: {},
        urunAciklamasi: ""
      },
      rand: "",
      urunFiyati: [],
      urunEskiFiyati: [],
      urunFiyatiIndirim: [],
      urunFiyatiIndirimStatus: [],
      urunSetEditorContent: "",
      aktifTutar: [],
      aktifNitelik: "",
      urunDataStatus: false,
      rules: {
        number: value =>
          Number.isInteger(parseInt(value)) ||
          value === "" ||
          "Sadece rakam içerebilir"
      },
      urunEkleBtnStatus: false,
      urunNitelikleri: [],
      urunNiteligi: "",
      urunTemelNitelikleri: [
        {
          name: "Tek Ürün",
          value: ["0"]
        },
        {
          name: "Renk Seçici",
          value: ["#000000"]
        }
      ],
      nitelikDegisDialog: false,
      bosFiyat: "0,00" + " ₺",
      defaultColor: "#353535",
      urunSecenekleriData: {
        dialog: false
      }
    };
  },
  computed: {
    ...mapState({
      urunAlanlari: state => state.Urunler.UrunEkle.urunAlanlari,
      urunBoyutlari: state => state.Urunler.UrunEkle.urunBoyutlari,
      kategoriListesi: state => state.Urunler.UrunCategories.kategoriListesi
    }),
    /**
     * @returns {Object}
     */
    router() {
      return this.$router;
    },
    nitelikTuru() {
      switch (this.urunNiteligi) {
        case "Tek Ürün":
          return 1;
        case "Renk Seçici":
          return 2;
        default:
          return 3;
      }
    }
  },
  methods: {
    /**
     * Ürün ekleme işlemi
     */
    urunEkle() {
      /**
       * Önce resimleri upload et sonra ürünü upload et
       */
      var urunAdi = this.urunData.urunAdi,
        urunKodu = this.urunData.urunKodu,
        urunKategorisi = this.urunData.urunKategorisi,
        urunAciklamasi = this.urunData.urunAciklamasi,
        urunOzellikleri = this.urunData.urunOzellikleri,
        urunFiyati = this.urunData.urunFiyati,
        urunStok = this.urunData.urunStok,
        urunNitelikleri = this.urunData.urunNitelikleri,
        urunSecenekleri = this.urunData.urunSecenekleri,
        urunResimleri = this.urunData.urunResimleri,
        token = this.$store.state.User.UserLogin.token;

      var formData = new FormData();

      formData.append("data[urunAdi]", urunAdi);
      formData.append("data[urunKodu]", urunKodu);
      formData.append("data[urunKategorisi]", urunKategorisi);
      formData.append("data[urunAciklamasi]", urunAciklamasi);

      formData.append("data[token]", token);
      formData.append("data[methodName]", "Module/Urunler/urunEkle");

      var urunO = false;
      Object.keys(urunOzellikleri).forEach(key => {
        formData.append(
          "data[urunOzellikleri][" + key + "]",
          urunOzellikleri[key]
        );
        urunO = true;
      });

      Object.keys(urunFiyati).forEach(nitelik => {
        formData.append(
          "data[urunFiyati][" + nitelik + "]",
          urunFiyati[nitelik]
        );
      });
      Object.keys(urunStok).forEach(nitelik => {
        formData.append("data[urunStok][" + nitelik + "]", urunStok[nitelik]);
      });
      urunNitelikleri.forEach(nitelik => {
        formData.append("data[urunNitelikleri][]", nitelik);
      });
      var urunBo = false;
      Object.keys(urunSecenekleri).forEach(nitelik => {
        if (Object.keys(urunSecenekleri[nitelik]).length) {
          Object.entries(urunSecenekleri[nitelik]).forEach(secenek => {
            if (secenek[1].length > 0) {
              secenek[1].forEach(s => {
                formData.append(
                  "data[urunSecenekleri][" +
                    nitelik +
                    "][" +
                    secenek[0] +
                    "][]",
                  s
                );
                urunBo = true;
              });
            } else {
              formData.append(
                "data[urunSecenekleri][" + nitelik + "][" + secenek[0] + "]",
                ""
              );
              urunBo = true;
            }
          });
        }
      });

      var urunB = false;
      Object.keys(urunResimleri).forEach(nitelik => {
        urunResimleri[nitelik].forEach(el => {
          formData.append("urunResimleri[" + nitelik + "][]", el.file);
          urunB = true;
        });
      });

      if (!urunO) {
        formData.append("data[urunOzellikleri][]", "");
      }
      if (!urunB) {
        formData.append("data[urunResimleri][]", "");
      }
      if (!urunBo) {
        formData.append("data[urunSecenekleri][]", "");
      }

      // console.log([...formData.entries()]);

      this.urunEkleBtnStatus = true;

      axios({
        url: process.env.VUE_APP_API_URL,
        data: formData,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        auth: {
          username: process.env.VUE_APP_API_USER,
          password: process.env.VUE_APP_API_PASS
        }
      }).then(res => {
        var response = res.data;
        if (response.status === 200) {
          this.$snotify.success("Ürün başarılı bir  eklenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
          this.$router.push("/panel/urunler/urun-listesi");
        } else {
          this.$snotify.error(response.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
        this.urunEkleBtnStatus = false;
      });
    },
    indirimBelirleKaldir() {
      if (this.urunFiyatiIndirimStatus[this.aktifNitelik]) {
        this.$set(this.urunFiyatiIndirimStatus, this.aktifNitelik, false);
        this.$set(this.urunData.urunEskiFiyati, this.aktifNitelik, "");
        this.$refs.urunEskiFiyati.formattedValue = "";
      } else {
        this.$set(this.urunFiyatiIndirimStatus, this.aktifNitelik, true);
      }
    },
    urunSecenekleriDialog() {
      this.urunSecenekleriData.dialog = true;
    },
    secenekEkle(secenekAdi) {
      if (!this.urunData.urunSecenekleri[this.aktifNitelik]) {
        this.$set(this.urunData.urunSecenekleri, this.aktifNitelik, {});
      }

      if (!this.urunData.urunSecenekleri[this.aktifNitelik][secenekAdi]) {
        this.$set(
          this.urunData.urunSecenekleri[this.aktifNitelik],
          secenekAdi,
          []
        );
      } else {
        let urunSecenekleri = {};
        for (let i in this.urunData.urunSecenekleri[this.aktifNitelik]) {
          if (i !== secenekAdi) {
            urunSecenekleri[i] = this.urunData.urunSecenekleri[
              this.aktifNitelik
            ][i];
          }
        }
        this.$set(
          this.urunData.urunSecenekleri,
          this.aktifNitelik,
          urunSecenekleri
        );
      }
    },
    secenekKontrol(nitelikAdi) {
      if (
        this.urunDataStatus &&
        Object.keys(this.urunData.urunSecenekleri[this.aktifNitelik])
      ) {
        return !!this.urunData.urunSecenekleri[this.aktifNitelik][nitelikAdi];
      } else {
        return false;
      }
    },
    tumSecenekleriSecKaldir(nitelikAdi) {
      let nitelik = this.nitelikGetir(nitelikAdi);
      if (
        this.urunData.urunSecenekleri[this.aktifNitelik][nitelikAdi].length !==
        nitelik.value.length
      ) {
        this.$set(
          this.urunData.urunSecenekleri[this.aktifNitelik],
          nitelikAdi,
          nitelik.value
        );
      } else {
        this.$set(
          this.urunData.urunSecenekleri[this.aktifNitelik],
          nitelikAdi,
          []
        );
      }
    },
    tumSeceneklerAktif(nitelikAdi) {
      if (nitelikAdi) {
        let nitelik = this.nitelikGetir(nitelikAdi);
        return (
          this.urunData.urunSecenekleri[this.aktifNitelik][nitelikAdi]
            .length === nitelik.value.length
        );
      }
    },
    fiyatFormat(fiyat) {
      fiyat = fiyat.replace(",", ".");

      var formatter = new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY"
      });

      let aktifTutar = formatter.format(fiyat).replace("₺", "");

      this.$set(this.aktifTutar, this.aktifNitelik, aktifTutar + " ₺");
    },
    // tumBoyutlar() {
    //   if (this.urunDataStatus) {
    //     if (
    //       this.urunData.urunBoyutlari[this.aktifNitelik].length !==
    //       this.urunBoyutlari.length
    //     )
    //       return true;
    //     else return false;
    //   }
    // },
    // tumBoyutlariSec() {
    //   if (this.urunDataStatus) {
    //     if (
    //       this.urunData.urunBoyutlari[this.aktifNitelik].length !==
    //       this.urunBoyutlari.length
    //     )
    //       this.urunData.urunBoyutlari[this.aktifNitelik] = this.urunBoyutlari;
    //     else this.urunData.urunBoyutlari[this.aktifNitelik] = [];
    //   }
    // },
    nitelikSecimi(items) {
      /**
       * Aktif Rengin değişme ihtimaline karşı değişim
       */
      if (items.length !== 0 && !items.includes(this.aktifNitelik)) {
        this.aktifNitelik = Object.values(this.urunData.urunNitelikleri)[0];
      }

      if (!items.length) {
        let ilkNitelik = this.urunNitelikleri.find(
          o => o.name === this.urunNiteligi
        ).value[0];
        this.$set(this.urunData, "urunNitelikleri", [ilkNitelik]);
        this.$set(this, "aktifNitelik", ilkNitelik);
      }

      if (items.length !== 0) {
        this.urunData.urunNitelikleri = items;
      } else {
        this.$set(
          this.urunData,
          "urunNitelikleri",
          this.urunData.urunNitelikleri
        );
      }
    },
    nitelikGetir(nitelikAdi) {
      return this.urunNitelikleri.find(o => o.name === nitelikAdi);
    },
    aktifNitelikText(renk = "") {
      if (!renk) renk = this.aktifNitelik;
      return TinyColor(renk).isLight()
        ? TinyColor(renk)
            .darken(100)
            .toString()
        : TinyColor(renk)
            .lighten(100)
            .toString();
    },
    /**
     * Butonlar için aktif renk tanımlaması yapar
     */
    aktifNitelikButon(renk = "") {
      if (this.nitelikTuru == 2) {
        if (!renk) renk = this.aktifNitelik;
        return {
          background: renk,
          color: this.aktifNitelikText(renk)
        };
      } else {
        return {
          background: this.defaultColor,
          color: this.aktifNitelikText(this.defaultColor)
        };
      }
    },
    isInt(value) {
      return !!value.match(/[A-Z]/g);
    },
    getStok(renk) {
      if (this.urunDataStatus) {
        return this.urunData.urunStok[renk] !== ""
          ? this.urunData.urunStok[renk] + ""
          : false;
      } else return false;
    },
    // getBoyut(renk) {
    //   if (this.urunDataStatus) {
    //     return this.urunData.urunBoyutlari[renk].length > 0
    //       ? this.urunData.urunBoyutlari[renk]
    //       : false;
    //   } else return false;
    // },
    formatFiyat(fiyat) {
      // parseFloat('5.535,99'.replace('.', '').replace(',', '.'))
      console.log(fiyat);
      fiyat = Number.isInteger(fiyat) ? fiyat : 0;
      console.log(fiyat);
      var formatter = new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY"
      });
      return formatter.format(fiyat).replace("₺", "");
    },
    urunBoyutKontrol(boyut) {
      if (this.urunDataStatus) {
        return this.urunData.urunBoyutlari[this.aktifNitelik].includes(boyut);
      } else return false;
    },
    filterStok(val) {
      this.$set(
        this.urunData.urunStok,
        this.aktifNitelik,
        val.target.value.match(/\d+/g, "")
      );
      val.target.value = this.urunData.urunStok[this.aktifNitelik];
    },
    routerPath(num) {
      let path = this.$route.path.split("/");
      for (let i = 0; i < num; i++) {
        path.pop();
      }
      return path.join("/");
    }
  },
  created() {
    /**
     * Ürün kategorilerini getir
     */
    this.$store.dispatch("Urunler/UrunCategories/kategoriListesi");

    /**
     * Ürün özel alanlarını getir
     */
    this.$store.dispatch("Urunler/UrunEkle/urunAlanlari").then(ozellikler => {
      /**
       * Ürün özellikleri ile v-model data içerisini
       * genişlet
       */
      if (ozellikler.length > 0) {
        ozellikler.data.forEach(ozellik => {
          this.urunData.urunOzellikleri[ozellik] = "";
        });
      }
    });
    /**
     * Ürüne ait boyutları getir
     */
    this.$store.dispatch("Urunler/UrunEkle/urunBoyutlari");

    /**
     * İlk rengi al ve v-model'ler için ayarla
     */
    this.aktifNitelik = this.urunData.urunNitelikleri[0];

    /**
     * ürün niteliklerini getir
     */
    UrunlerService.nitelikListesi().then(res => {
      if (res.status === 200) {
        this.urunNitelikleri = this.urunTemelNitelikleri.concat(
          res.data.map(o => ({ name: o.name, value: o.items }))
        );
      } else {
        this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        let realPath = this.routerPath(1);
        this.$router.push(realPath);
      }
    });
  },
  watch: {
    "urunData.urunFiyati": {
      handler(value) {
        if (Object.keys(value).length) {
          value = value[this.aktifNitelik];

          if (!value) {
            this.$set(this.urunFiyati, this.aktifNitelik, this.bosFiyat);
          } else {
            let formatter = new Intl.NumberFormat("tr-TR", {
              style: "currency",
              currency: "TRY"
            });
            let fiyat = formatter.format(value).replace("₺", "");
            this.$set(this.urunFiyati, this.aktifNitelik, fiyat + " ₺");
          }
        }
      },
      deep: true,
      immediate: true
    },
    "urunData.urunEskiFiyati": {
      handler(value) {
        if (Object.keys(value).length) {
          value = value[this.aktifNitelik];

          if (!value) {
            this.$set(this.urunEskiFiyati, this.aktifNitelik, this.bosFiyat);
          } else {
            let formatter = new Intl.NumberFormat("tr-TR", {
              style: "currency",
              currency: "TRY"
            });
            let fiyat = formatter.format(value).replace("₺", "");
            this.$set(this.urunEskiFiyati, this.aktifNitelik, fiyat + " ₺");
          }
        }
      },
      deep: true,
      immediate: true
    },
    "urunData.urunNitelikleri"(nitelikler) {
      if (!nitelikler.length) return;

      nitelikler.forEach(nitelik => {
        if (this.urunData.urunFiyati[nitelik] === undefined) {
          this.$set(this.urunData.urunFiyati, nitelik, "");
          this.$set(this.urunData.urunEskiFiyati, nitelik, "");
          this.$set(this.urunData.urunStok, nitelik, "");
          this.$set(this.urunData.urunResimleri, nitelik, []);
          this.$set(this.urunData.urunSecenekleri, nitelik, {});
          this.$set(this.urunFiyati, nitelik, this.bosFiyat);
          this.$set(this.urunEskiFiyati, nitelik, this.bosFiyat);
        }
      });

      /**
       * Daha önce silinmiş ama dizide kalan nitelikleri
       * temizle
       */
      let field = {};
      Object.keys(this.urunData.urunFiyati).forEach(key => {
        if (nitelikler.includes(key)) {
          field[key] = this.urunData.urunFiyati[key];
        }
      });
      this.$set(this.urunData, "urunFiyati", field);

      field = {};
      Object.keys(this.urunData.urunEskiFiyati).forEach(key => {
        if (nitelikler.includes(key)) {
          field[key] = this.urunData.urunEskiFiyati[key];
        }
      });
      this.$set(this.urunData, "urunEskiFiyati", field);

      field = {};
      Object.keys(this.urunFiyati).forEach(key => {
        if (nitelikler.includes(key)) {
          field[key] = this.urunFiyati[key];
        }
      });
      this.$set(this, "urunFiyati", field);

      field = {};
      Object.keys(this.urunEskiFiyati).forEach(key => {
        if (nitelikler.includes(key)) {
          field[key] = this.urunEskiFiyati[key];
        }
      });
      this.$set(this, "urunEskiFiyati", field);

      Object.keys(this.urunData.urunStok).forEach(key => {
        if (!nitelikler.includes(key)) delete this.urunData.urunStok[key];
      });

      Object.keys(this.urunData.urunSecenekleri).forEach(key => {
        if (!nitelikler.includes(key))
          delete this.urunData.urunSecenekleri[key];
      });

      Object.keys(this.urunData.urunResimleri).forEach(key => {
        if (!nitelikler.includes(key)) delete this.urunData.urunResimleri[key];
      });

      this.$set(this, "urunFiyatiIndirimStatus", []);

      /**
       * Urun data set edildi
       */
      this.urunDataStatus = true;
    },
    urunNiteligi: {
      handler(value) {
        this.urunData.urunNitelikleri = [];

        if (
          !this.urunData.urunNitelikleri.length &&
          this.urunNitelikleri.length
        ) {
          let ilkNitelik = this.urunNitelikleri.find(o => o.name === value)
            .value[0];
          this.$set(this.urunData, "urunNitelikleri", [ilkNitelik]);
          this.$set(this, "aktifNitelik", ilkNitelik);
        }
      },
      immediate: true
    }
  },
  updated() {
    // console.log(this.urunData.urunBoyutlari);
    // console.log(this.urunData.urunResimleri);
  }
};
</script>

<style>
#onizlemeBilgiGir {
  position: relative;
  top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  border-radius: 15px;
  background-color: #f9f9f9;
  border: 2px dashed #aaa;
}

#onizlemeBilgiGir > div {
  text-align: center;
  width: 75%;
  font-size: 25px;
  font-weight: 500;
  color: #aaa;
}

.onizleme-yok {
  background: #ffffff87;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 5;
}
.onizleme-yok > div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 21px;
  width: 75%;
  font-weight: bold;
}
.urun-alan {
  width: 30%;
  margin-right: 20px;
}
.color1,
.colors > li:nth-child(1),
.group-two {
  background-color: #d33f4b;
}

.color2,
.colors > li:nth-child(2) {
  background-color: #545151;
}

.color3,
.colors > li:nth-child(3) {
  background-color: #5695c3;
}

.color4,
.colors > li:nth-child(4) {
  background-color: #0f8a5f;
}

.color5,
.colors > li:nth-child(5) {
  background-color: #235e6f;
}

.shoe--name {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
}

.shoe--price {
  color: #333;
  font-size: 18px;
  display: block;
  margin-bottom: 10px;
}

.shoe--code {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #555;
}

.group {
  min-height: 760px;
  height: 100vh;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  background-image: url(https://bit.ly/2lpu3Uh);
  background-blend-mode: multiply;
}
.group .group--container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 0 60px 0;
  display: -webkit-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.group .group--title {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  width: 100%;
  text-transform: uppercase;
  margin-bottom: 100px;
}
.group .group--title h1,
.group .group--title h2,
.group .group--title h3,
.group .group--title h4 {
  font-family: "Roboto";
  font-weight: 700;
  font-family: Futura, Futura-Medium, "Futura Medium", "Century Gothic",
    CenturyGothic, "Apple Gothic", AppleGothic, "URW Gothic L", "Avant Garde",
    sans-serif;
  font-size: 32px;
  margin: 0 0 10px 0;
}
.group .group--title h1:before,
.group .group--title h2:before,
.group .group--title h3:before,
.group .group--title h4:before {
  content: "";
  display: block;
  border-top: 4px solid #232323;
  padding-top: 18px;
  width: 43%;
  margin: 0 auto;
}
.group .group--subtitle {
  font-weight: 400;
  font-family: "Roboto", sans-serif;
  color: #777;
  letter-spacing: 0.6px;
}

.card {
  width: 315px;
  height: 400px;
  background: #fff;
  margin: 0 15px;
  padding: 60px 33px 12px 33px;
  box-sizing: border-box;
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  position: relative;
  display: block;
}
.card .shoe img {
  max-width: 100%;
  width: 250px;
  margin-bottom: 120px;
  position: relative;
}
.card .shoe--info {
  position: absolute;
  bottom: -70px;
  text-align: center;
  width: 100%;
  left: 0;
}
.card .shoe--info .shoe--name {
  margin-bottom: 8px;
}
.card .shoe--info .shoe--price {
  font-weight: 400;
  color: #757575;
  font-size: 14px;
}
.card .shoe--colors {
  padding: 23px 0 0 0;
  border-top: 1px solid #f4f4f5;
  bottom: 40px;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin: 0;
}

.colors {
  margin: 0;
  padding: 0;
  width: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: start;
  justify-content: flex-start;
}
.colors > li {
  list-style: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  margin: 0 4px;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition: all ease 1s;
  transition: all ease 1s;
}
.colors > li:hover {
  -webkit-transform: scale(1.09);
  transform: scale(1.09);
  -webkit-transition: all ease 1s;
  transition: all ease 1s;
}

.buy-btn {
  width: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  font-size: 14px;
  outline: 0;
  background-color: transparent;
  box-shadow: none;
  border: 2px solid #afafaf;
  text-transform: uppercase;
  padding: 8px 19px;
  display: flex;
  align-items: center;
  border-radius: 3px;
  font-weight: 400;
  font-family: "Roboto", sans-serif;
  color: #afafaf;
}

.card--style2 {
  width: 330px;
  height: 360px;
  padding: 0;
  position: relative;
  box-sizing: border-box;
}
.card--style2 .shoe {
  padding-bottom: 50px;
  position: absolute;
  bottom: 0;
  will-change: transform;
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.card--style2 .shoe:before {
  content: "";
  display: block;
  background: #fff;
  height: 310px;
  width: 200px;
  position: absolute;
  bottom: 50px;
  left: 90px;
}
.card--style2 .shoe img {
  width: 100%;
  position: relative;
}
.card--style2 .shoe--info {
  position: relative;
  top: 30px;
  z-index: 5;
  will-change: transform;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
  -webkit-transform-origin: center center;
  transform-origin: center center;
}
.card--style2 .shoe--name:before {
  content: "";
  padding-top: 13px;
  width: 190px;
}
.card--style2 .shoe--colors {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
}
.card--style2 .shoe--colors .colors {
  width: auto;
  margin: 0 auto;
  position: relative;
  left: 10px;
  will-change: transform;
  opacity: 0;
  -webkit-transform: translateY(8px);
  transform: translateY(8px);
  -webkit-transition: all 0.33s ease-in;
  transition: all 0.33s ease-in;
  -webkit-transition-delay: 0.153s;
  transition-delay: 0.153s;
}
.card--style2:hover .shoe--colors .colors {
  opacity: 1;
  -webkit-transform: translateY(0);
  transform: translateY(0);
  -webkit-transition: all 0.33s ease-out;
  transition: all 0.33s ease-out;
  -webkit-transition-delay: 0.253s;
  transition-delay: 0.253s;
}
.card--style2:hover .shoe {
  -webkit-transform: scale(1.06);
  transform: scale(1.06);
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.card--style2:hover .shoe--info {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.card--style2.card--one .shoe--name:before {
  border-top: 5px solid red;
}
.card--style2.card--two .shoe--name:before {
  border-top: 5px solid black;
}
.card--style2.card--three .shoe--name:before {
  border-top: 5px solid #5695c3;
}

.group-one {
  background-color: #eaeaea;
  background-image: none;
}
.group-one .group--title h1:before,
.group-one .group--title h2:before,
.group-one .group--title h3:before,
.group-one .group--title h4:before {
  border-color: #d33f4b;
}

.group-two .group--title {
  color: rgba(250, 250, 250, 0.85);
}
.group-two .group--title h1:before,
.group-two .group--title h2:before,
.group-two .group--title h3:before,
.group-two .group--title h4:before {
  border-color: rgba(250, 250, 250, 0.9);
}
.group-two .group--subtitle {
  color: rgba(250, 250, 250, 0.85);
}
.group-two .is--active {
  -webkit-transform: scale(1.2);
  transform: scale(1.2);
  -webkit-transform-origin: center center;
  transform-origin: center center;
}
.group-two .shoe--info .shoe--name {
  color: #fff;
}
.group-two .shoe--info .shoe--price {
  color: #fff;
}

.group-three {
  background-image: none;
  background-color: #f4f4f4;
}
.group-three .shop-all {
  width: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  margin: 120px 0 0 0;
}
.group-three .shop-all .button {
  border: 3px solid #444;
  outline: 0;
  background-color: transparent;
  border-radius: 2px;
  padding: 9px 18px;
  font-size: 13px;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  -webkit-transition: all 0.23s ease;
  transition: all 0.23s ease;
  -webkit-transform: scale(1);
  transform: scale(1);
}
.group-three .shop-all .button:hover {
  background-color: #232323;
  color: #fff;
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
  -webkit-transition: all 0.23s ease;
  transition: all 0.23s ease;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#cardFiyatStok {
  width: 100%;
  display: flex;
  justify-content: center;
}
#cardFiyatStok > span:nth-child(2) {
  flex-basis: 20%;
  text-align: center;
}
.indirim-btn {
  top: -3px;
}
.urun-fiyatlandirma-wrapper {
  display: flex;
}
.urun-fiyatlandirma-wrapper > div {
  flex-basis: 100%;
}
</style>